
import TickIcon from '~/assets/icons/tick.svg'
export default {
  components: {
    TickIcon
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    relatedProduct: {
      type: Object,
      required: true
    },
    featureOptions: {
      type: Array,
      required: true
    },
    productProperty: {
      type: String,
      required: true
    },
    activeOptionProperty: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    activeOption () {
      return this.product[this.activeOptionProperty] ? this.featureOptions[0] : this.featureOptions[1]
    },
  },
  methods: {
    isActive (element) {
      return element === this.activeOption
    },
    handleClick (element) {
      if (this.isActive(element) || !this.relatedProduct?.url) {
        return
      }
      this.gtm_trackFeatureToggleClick(
        this.relatedProduct.relation,
        {
          sourceProduct: {
            name: this.product.name,
            sku: this.product.sku,
            url: this.product.url,
            toggleValue: this.product[this.productProperty],
          },
          targetProduct: {
            name: this.relatedProduct.name,
            sku: this.relatedProduct.sku,
            url: this.relatedProduct.url,
            toggleValue: this.relatedProduct[this.productProperty],
          },
          variant: this.relatedProduct.variantName,
        },
        element
      )
      this.$router.push(this.relatedProduct?.url ?? '')
    },
    getDisplayValue (product, productProperty) {
      if (productProperty === 'shaping') {
        if (product.isLightShaping) {
          return this.$t('Toggle_Shaping_Option_Light_Shaping')
        }
        return this.$t('Toggle_Shaping_Option_No_Shaping')
      } else if (productProperty === 'sidewing') {
        if (product.hasSideWing) {
          return this.$t('Toggle_SideWing_Option_Yes_Side_Wing')
        }
        return this.$t('Toggle_SideWing_Option_No_Side_Wing')
      } else if (productProperty === 'material_aspect') {
        if (product.hasLace) {
          return product.material_aspect
        }
        return this.$t('Related_Lace_Product_Material_Plain')
      }
      return product[productProperty]
    },
  }
}
